import { SecurityZoneListPanel } from '@/components/features/applications/security-zones/SecurityZoneListPanel';
import { isSmokeCoZone } from '@/lib/enum-resolvers';

export function SmokeCoZonesPanel() {
  return (
    <SecurityZoneListPanel
      title="Smoke/CO"
      description="Monitor smoke and carbon monoxide detection zones"
      emptyTitle="No Smoke/CO Zones"
      emptyDescription="No smoke or carbon monoxide zones are configured on this device."
      emptyIconPath="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
      noZonesTitle="No Smoke/CO Zones"
      noZonesDescription="No smoke or carbon monoxide zones are active on this device."
      filterFn={isSmokeCoZone}
    />
  );
}
